module.exports = __webpack_public_path__ + "img/1 (49).7a953171.png";